export const sectionConfig = {
  "items": [
    {
      "title": "دانش شخصی شما، حافظه هوش مصنوعی: قابلیت‌های Knowledge و Notes",
      "caption": "با قابلیت‌های پیشرفته Knowledge و Notes در Fig AI، اطلاعات اختصاصی خود را ذخیره و مدیریت کنید و با استفاده از System Prompt، هوش مصنوعی را برای همیشه مطابق با نیازهایتان تنظیم کنید.   ",
      "link": "/blog/notes-knowledge"
    },
    {
      "title": "فراتر از متن: قابلیت Code Execution، هوش مصنوعیِ تحلیل‌گر",
      "caption": "با قابلیت جدید Code Execution، هوش مصنوعی Fig AI نه تنها کد می‌نویسد، بلکه آن را اجرا کرده و خروجی‌هایی نظیر نمودارهای حرفه‌ای و محاسبات دقیق ارائه می‌دهد.   ",
      "link": "/blog/code-execution"
    },
    {
      "title": "از متن تا تصویر: خلق فلوچارت و دیاگرام با هوش مصنوعی فیگ",
      "caption": "آیا می‌دانستید با هوش مصنوعی فیگ می‌توانید پیچیده‌ترین فلوچارت‌ها و نمودارها را بدون کشیدن حتی یک خط، فقط با نوشتن متن خلق کنید؟",
      "link": "/blog/mermaid-rendering"
    },
    {
      "title": "با Multi-Model همزمان با چند هوش مصنوعی گفتگو کنید",
      "caption": "دیگر نیازی به انتخاب یک مدل نیست. در Fig AI می‌توانید چندین مدل هوش مصنوعی را همزمان فراخوانی کنید تا پاسخ‌ها را از زوایای مختلف بررسی کنید.  ",
      "link": "/blog/multi-model"
    },
    {
      "title": "دسترسی به جستجو بدون سانسور در اینترنت آزاد",
      "caption": "با مدل‌های جدید Sonar و Sonar-Pro در Fig AI، محدودیت‌های جستجو را کنار بزنید و به نتایج اینترنت بین‌الملل بدون سانسور دسترسی پیدا کنید.  ",
      "link": "/blog/sonar-model"
    }
  ]
}

export type SectionConfig = typeof sectionConfig
